"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortElementsByOrder = (elements) => {
    return Array.isArray(elements)
        ? elements.sort((e1, e2) => {
            return typeof e1.order === 'number' && typeof e2.order === 'number'
                ? e1.order - e2.order
                : 0;
        })
        : elements;
};
//# sourceMappingURL=sortElementsByOrder.js.map